import { GAME, VIEW_H, VIEW_W } from '../config/config';
import { C } from '../gfx/palette';
import type { Renderer } from '../gfx/renderer';
import type { Level, Session } from '../game/level';

export interface DebugInfo {
  fps: number;
  steps: number;
}

/** On-canvas status bar and debug readout. */
export class Hud {
  draw(r: Renderer, level: Level, session: Session, levelLabel: string, blinkTime: number): void {
    const ctx = r.ctx;
    // translucent band so the HUD stays readable over bright skies
    ctx.globalAlpha = 0.35;
    r.rectScreen(0, 0, VIEW_W, 20, C.black);
    ctx.globalAlpha = 1;

    r.textShadow('SCORE', 6, 3, C.hud);
    r.textShadow(pad(session.score, 6), 6, 11, C.gold);

    r.textShadow('SUNBIT', 56, 3, C.hud);
    // little coin pip drawn inline so the icon lines up with the 5x7 font
    r.rectScreen(57, 11, 4, 7, C.coinDark);
    r.rectScreen(58, 12, 2, 5, C.coin);
    r.textShadow(`×${pad(session.coins, 2)}`, 64, 11, C.hud);

    r.textShadow('BLOOM', 116, 3, C.hud);
    r.textShadow(`×${Math.max(0, session.lives)}`, 122, 11, C.pod);

    r.textShadow('VALE', 158, 3, C.hud);
    r.textShadow(levelLabel, 158, 11, C.hud);

    const time = Math.max(0, Math.ceil(level.timeLeft));
    const low = time <= GAME.timeWarn;
    const flash = low && Math.floor(blinkTime * 4) % 2 === 0;
    r.textShadow('TIME', VIEW_W - 6, 3, C.hud, 'right');
    r.textShadow(pad(time, 3), VIEW_W - 6, 11, flash ? C.red : C.hud, 'right');
  }

  drawDebug(r: Renderer, level: Level, info: DebugInfo): void {
    const lines = [
      `FPS ${info.fps.toFixed(0)} STEP ${info.steps}`,
      level.player.debugLine,
      `POS ${level.player.x.toFixed(1)} ${level.player.y.toFixed(1)}`,
      `CAM ${level.camera.x.toFixed(0)} ${level.camera.y.toFixed(0)} AREA ${level.areaId}`,
      `ENT ${level.activeEntityCount}/${level.totalEntityCount} PHASE ${level.phase}`,
    ];
    const h = lines.length * 8 + 4;
    r.ctx.globalAlpha = 0.6;
    r.rectScreen(2, VIEW_H - h - 2, 150, h, C.black);
    r.ctx.globalAlpha = 1;
    lines.forEach((l, i) => r.text(l, 5, VIEW_H - h + 1 + i * 8, C.prismLight));
  }
}

function pad(v: number, n: number): string {
  return Math.max(0, Math.floor(v)).toString().padStart(n, '0');
}
